// Tim pekerjaan Operator Bordir: Bagi Pekerjaan (bersamaan), Lanjutkan Pekerjaan (serah), Mulai Kerjakan, Scan untuk Melanjutkan.
import { useEffect, useState } from "react";
import axios from "axios";
import { ClaimDialog, errText } from "./bordir_claim_dialog";
import ScanMockupModal from "./scan_mockup";
import "./bordir_claims.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const opt = { withCredentials: true };

export function teamRole(team, holderName, meName) {
  const t = team || {};
  if (!meName) return "";
  if (holderName && holderName === meName) return "holder";
  if ((t.active || []).includes(meName)) return "active";
  if ((t.assigned || []).includes(meName)) return "assigned";
  return "";
}

export function teamLines(team, holderName) {
  const t = team || {};
  if (t.waiting) return [["Menunggu Dilanjutkan", "scan barcode mockup untuk mengambil"]];
  const act = [...new Set([holderName, ...(t.active || [])].filter(Boolean))];
  const out = [];
  if (act.length) out.push(["Sedang bekerja", act.join(", ")]);
  if ((t.assigned || []).length) out.push(["Belum mulai", t.assigned.join(", ")]);
  if ((t.done || []).length) out.push(["Bagian selesai", t.done.join(", ")]);
  return out;
}

export const teamLabel = (team, holderName) => teamLines(team, holderName).map(([k, v]) => `${k}: ${v}`).join(" · ");

function AssignDialog({ orderNumber, productId, team, holderName, onClose, onDone }) {
  const [ops, setOps] = useState(null);
  const [sel, setSel] = useState([]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => { axios.get(`${API}/bordir-team/operators`, opt).then(r => setOps(r.data.items || [])).catch(e => setErr(errText(e))); }, []);
  const taken = new Set([holderName, ...((team || {}).active || []), ...((team || {}).assigned || [])]);
  const save = async () => {
    setBusy(true); setErr("");
    try { await axios.post(`${API}/bordir-team/assign`, { order_number: orderNumber, product_id: productId, operator_ids: sel }, opt); onDone(); }
    catch (e) { setErr(errText(e)); } finally { setBusy(false); }
  };
  return <div className="bcl-backdrop" onClick={e => { e.stopPropagation(); if (!busy) onClose(); }} data-testid="team-assign-dialog">
    <div className="bcl-sheet" onClick={e => e.stopPropagation()}>
      <div className="bcl-head"><b>Bagi Pekerjaan</b><button className="soft-btn small-btn" onClick={onClose} disabled={busy} data-testid="team-assign-close">Tutup</button></div>
      <small className="bcl-sub">Pilih operator yang ikut mengerjakan bersama Anda.</small>
      {!ops && !err && <small>Memuat…</small>}
      <div className="btm-ops">
        {(ops || []).filter(o => o.name !== holderName).map(o => {
          const dis = taken.has(o.name);
          return <label key={o.id} className={`btm-op ${dis ? "is-taken" : ""} ${sel.includes(o.id) ? "is-on" : ""}`} data-testid={`team-assign-op-${o.id}`}>
            <input type="checkbox" disabled={dis} checked={dis || sel.includes(o.id)} onChange={e => setSel(s => e.target.checked ? [...s, o.id] : s.filter(x => x !== o.id))} />
            <span className="btm-op-name">{o.name}</span>{dis && <span className="btm-op-tag">Sudah ditugaskan</span>}
          </label>;
        })}
        {ops && !ops.filter(o => o.name !== holderName).length && <small className="bcl-sub">Tidak ada operator Bordir aktif lain.</small>}
      </div>
      {err && <small className="bcl-err" data-testid="team-assign-error">{err}</small>}
      <button className="primary bcl-save" disabled={busy || !sel.length} onClick={save} data-testid="team-assign-save">{busy ? "Menyimpan…" : "Simpan Pembagian"}</button>
    </div>
  </div>;
}

// Tiga tombol kartu Sedang Dikerjakan (pemegang) / tombol operator pembantu.
export function BordirTeamActions({ orderNumber, productId, team, holderName, meName, label, onChanged, testid }) {
  const [dlg, setDlg] = useState("");
  const [busy, setBusy] = useState(false);
  const role = teamRole(team, holderName, meName);
  const it = { order_number: orderNumber, product_id: productId };
  const done = () => { setDlg(""); onChanged && onChanged(); };
  const start = async () => {
    setBusy(true);
    try { await axios.post(`${API}/bordir-team/start`, it, opt); onChanged && onChanged(); } catch (e) { window.alert(errText(e)); } finally { setBusy(false); }
  };
  const id = testid || productId;
  if (team?.waiting || !role) return null;
  return <div className="btm-actions" onClick={e => e.stopPropagation()}>
    {role === "assigned" && <button className="primary btm-main" disabled={busy} onClick={start} data-testid={`team-start-${id}`}>Mulai Kerjakan</button>}
    {role === "active" && <button className="primary btm-main" onClick={() => setDlg("part")} data-testid={`team-part-${id}`}>Selesai Bagian Saya</button>}
    {(role === "holder" || role === "active") && <div className="btm-row">
      {role === "holder" && <button className="soft-btn" onClick={() => setDlg("assign")} data-testid={`team-assign-${id}`}>Bagi Pekerjaan</button>}
      <button className="soft-btn" onClick={() => setDlg("handoff")} data-testid={`team-handoff-${id}`}>Lanjutkan</button>
    </div>}
    {dlg === "assign" && <AssignDialog orderNumber={orderNumber} productId={productId} team={team} holderName={holderName} onClose={() => setDlg("")} onDone={done} />}
    {(dlg === "part" || dlg === "handoff") && <ClaimDialog orderNumber={orderNumber} productId={productId} label={label} onClose={() => setDlg("")} onChanged={onChanged}
      finalize={dlg === "part"
        ? { label: "Simpan & Selesai Bagian Saya", path: "/bordir-team/part-done", note: "Bagian Anda selesai. Pesanan tetap berjalan sampai seluruh pekerjaan tuntas.", onDone: done }
        : { label: "Simpan & Lanjutkan", path: "/bordir-team/handoff", allowEmpty: role === "active",
            note: "Hasil Anda tercatat dan Anda berhenti dari pekerjaan ini. Bila tidak ada rekan aktif, status menjadi Menunggu Dilanjutkan (penerus wajib scan barcode).", onDone: done }} />}
  </div>;
}

// Selesai pemegang yang BELUM mencatat hasil pada pekerjaan bertim/Catat Hasil → formulir dua kolom ("Simpan & Selesai").
// Sudah mencatat → kartu langsung Selesai (lihat finishNeedsForm), tanpa catatan tambahan.
export const needsFinishForm = (info, team, meName) => (!!team || (info?.used || 0) > 0) && !(info?.operators || []).includes(meName);
export function FinishWithClaim({ orderNumber, productId, label, onFinish, onClose }) {
  return <ClaimDialog orderNumber={orderNumber} productId={productId} label={label} onClose={onClose}
    finalize={{ label: "Simpan & Selesai", run: onFinish, finish: true, note: "", onDone: onClose }} />;
}

// Pekerjaan Menunggu Dilanjutkan: penerus wajib scan barcode mockup.
export function ResumeScanButton({ operator, user, onChanged, testid }) {
  const [open, setOpen] = useState(false);
  const go = async (num) => {
    setOpen(false);
    if (!num) return;
    try { await axios.post(`${API}/bordir-team/resume`, { code: String(num) }, opt); window.alert(`Pekerjaan ${num} dilanjutkan oleh Anda`); onChanged && onChanged(); }
    catch (e) { window.alert(errText(e)); }
  };
  return <>
    <button type="button" className="primary small-btn" onClick={e => { e.stopPropagation(); setOpen(true); }} data-testid={testid || "team-resume-scan"}>Scan untuk Melanjutkan</button>
    <ScanMockupModal open={open} onClose={() => setOpen(false)} operator={operator} user={user} onOpenOrder={go} searchOnly />
  </>;
}

export function TeamStatus({ team, holderName, testid }) {
  const lines = teamLines(team, holderName);
  if (!lines.length) return null;
  return <div className={`btm-status ${team?.waiting ? "is-wait" : ""}`} data-testid={testid}>
    {lines.map(([k, v]) => <div key={k}><span>{k}:</span> <b>{v}</b></div>)}
  </div>;
}
